export default __webpack_public_path__ + "static/media/diversity.5706378a.jpg";